import isEmpty from 'lodash/isEmpty';
import { buildWindChartSeries } from '~/utils/wind_rose';
import type { IWindRoseWidgetStore } from '.';

export default (self: IWindRoseWidgetStore) => ({
  get node() {
    return self.nodes?.getById(self.node_id);
  },
  get windDirectionDataPoint() {
    return self.wind_direction_data_point_id ? self.nodes?.getDataPointByDataPointId(self.wind_direction_data_point_id) : undefined;
  },
  get windSpeedDataPoint() {
    return self.wind_speed_data_point_id ? self.nodes?.getDataPointByDataPointId(self.wind_speed_data_point_id) : undefined;
  },
  get windChartSeries() {
    return buildWindChartSeries(self.windDirectionDataPoint, self.windSpeedDataPoint);
  },
  get title() {
    return isEmpty(self.name) ? self.node?.presentName : self.name;
  }
});
